<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="warehouse.Name" label="Tên kho" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="warehouse.ShortName" label="Tên viết tắt" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-switch v-model="warehouse.IsAutoCustomer" label="Tự động chia khách" class="input-group--focused"></v-switch>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.warehouse.loading,
            warehouse: state => state.warehouse.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("warehouse/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("warehouse/setDetail", { data: {
                        ID: 0,
                        Name: '',
                        ShortName: '',
                        IsAutoCustomer: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("warehouse/setDetail", {
                data: this.warehouse,
                id: this.warehouse.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "WarehouseList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.warehouse.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>